module.exports = __webpack_public_path__ + "images/icon-warning.294b7d8.svg";